import React, { useEffect, useState } from "react";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import SubscriptionsLoader from "../../Loaders/SubscriptionsLoader";
import SubscriptionsIntervalLoader from "../../Loaders/SubscriptionsIntervalLoader";
import { useLanguage } from "../../Translations/LenguageContext";

const SubscriptionStep = ({
    handleStep,
    soundClick,
    error,
    loadingSteps,
    packages,
    loadingPackages,
    subscription,
    setSelectedSubscription,
    selectedInterval,
    setSelectedInterval,
}) => {
    const { t } = useLanguage()
    

    const clickAction = (item) => {
        soundClick()
        setSelectedSubscription(item.id)
    }

    const handleContinue = () => {
        if (subscription.startsWith("pkg_one_time_pay_as_you_go")) {
            handleStep("continue", "done")
        } else if (subscription.startsWith("pkg_custom_enterprise")) {
            handleStep("continue", "done")
        } else {
            handleStep("continue", "payment-method")
        }
    }

    const filteredPackages = packages.filter((item) => {
        if (item.type === "one_time") return true;
        return item.type === selectedInterval;
    });

    useEffect(() => {
        if (packages.length > 0 && !subscription) {
            setSelectedSubscription(packages[0]["id"])
            setSelectedInterval("monthly")
        }
    }, [loadingPackages])

    return (
        <div className="steps_main_container">
            <div className="welcome_step_cont">
                <div className="welcome_step_cont_inner">
                    <p className="step_title fade-in">{t.website.pricing.title}</p>
                    <p className="step_description fade-in">{t.website.pricing.subtitle}</p>
                    {loadingPackages ? (
                        <SubscriptionsIntervalLoader />
                    ) : (
                        <div className="monthly_yearly_cont">
                            <button className={`monthly_yearly_choise fade-in ${selectedInterval == "monthly" && "monthly_yearly_choise_selected"}`} onClick={() => { setSelectedInterval("monthly") }}>{t.website.pricing.monthly}</button>
                            <button className={`monthly_yearly_choise fade-in ${selectedInterval == "yearly" && "monthly_yearly_choise_selected"}`} onClick={() => { setSelectedInterval("yearly") }}>{t.website.pricing.yearly}</button>
                            <button className={`monthly_yearly_choise fade-in ${selectedInterval == "custom" && "monthly_yearly_choise_selected"}`} onClick={() => { setSelectedInterval("custom") }}>{t.website.pricing.custom}</button>
                        </div>
                    )
                    }
                    <div className="subscriptions_cont">
                        {loadingPackages ? (
                            <SubscriptionsLoader />
                        ) : (
                            filteredPackages.length > 0 ? (
                                filteredPackages.map((item) => (
                                    <div
                                        key={item.id}
                                        className={`subscriptions_item fade-in ${subscription == item.id && "subscriptions_item_selected"}`}
                                    >
                                        <p className="subscriptions_item_tile fade-in">
                                            {item.name}
                                            {(item.type !== "one_time" && item.type !== "custom") && (
                                                <span className="subscriptions_item_price fade-in">
                                                    ${Number(item.price).toFixed(2)}
                                                </span>
                                            )}
                                        </p>

                                        <p className="subscriptions_item_desc fade-in">{item.description}</p>


                                        {item.name == "Pay as you go" ? (
                                            <p className="subscriptions_item_discount_mex_no_color fade-in">No discount</p>
                                        ) : item.name == "Enterprise" ? (
                                            <p className="subscriptions_item_discount_mex fade-in">Tailored discount</p>
                                        ) : (
                                            <p className="subscriptions_item_discount_mex fade-in">{item.discount_percentage}% discount on all usage</p>
                                        )}

                                        {((item.name === "Starter" || item.name === "Growth" || item.name === "Pro") && item.type == "yearly") && (
                                            <div className="subscriptions_item_discount fade-in">
                                                <strong>-10% yearly</strong>
                                            </div>
                                        )}

                                        <div
                                            className={`subscriptions_item_btn fade-in ${subscription == item.id && "subscriptions_item_btn_selected"}`}
                                            onClick={() => clickAction(item)}
                                        >
                                            Select
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="organizations_cont_no_items_mex fade-in">
                                    <p>No packages available.</p>
                                </div>
                            )
                        )}
                    </div>
                    <p className="pricing_info_mex" dangerouslySetInnerHTML={{ __html: t.website.pricing.more_info }}>

                    </p>
                </div >
            </div >

            <div className="steps_btn_cont">
                <button
                    className="steps_btn"
                    onClick={() => handleStep("back", "people")}
                >
                    <i className="fa-solid fa-chevron-left"></i> {t.onboarding.back}
                </button>
                <div>
                    <ErrorMessage err={error} />
                </div>
                <button className="steps_btn fade-in" disabled={loadingPackages} onClick={handleContinue}>
                    {loadingSteps ? (
                        <Spinner loading={true} />
                    ) : (
                        <>{t.onboarding.continue} <i className="fa-solid fa-chevron-right"></i></>
                    )}
                </button>
            </div>
        </div >
    );
};

export default SubscriptionStep;